import { CloudIcon, HomeIcon, ScaleIcon } from "@/lib/icons"
import { BsFillLightningFill } from "react-icons/bs"
import { useTrans } from "@/i18n"
import { MiniGraph } from "./MiniGraph"

// Dates
import { ms } from "@/lib/dates"

/**
 * GlobalOverview
 * @returns
 */
export const GlobalOverview = () => {
	const t = useTrans(["dashboard", "common"])
	const interval = ms("1 day")
	const interval1month = ms("90 days")
	const now = Number(new Date())

	return (
		<>
			<MiniGraph
				icon={HomeIcon}
				title={t("dashboard:dashboard.global_overview.stat1.title")}
				data={[
					[now - interval1month * 3, 50334 / 2.3],
					[now - interval1month * 2, 50334 / 2.2],
					[now - interval1month, 50334 / 1.3],
					[now, 50334],
				].map(([time, value]) => ({
					date: `${time}`,
					value,
				}))}
			/>
			<MiniGraph
				icon={ScaleIcon}
				title={t("dashboard:dashboard.global_overview.stat3.title")}
				data={[
					[now + interval * 1, 21454967 / 2.1],
					[now + interval * 2, 21454967 / 2],
					[now + interval * 3, 21454967 / 1.9],
					[now + interval * 4, 21454967 / 1.7],
					[now + interval * 5, 21454967 / 1.6],
					[now + interval * 6, 21454967 / 1.3],
					[now + interval * 7, 21454967 / 1.1],
					[now + interval * 8, 21454967],
				].map(([time, value]) => ({
					date: `${time}`,
					value,
				}))}
			/>

			<MiniGraph
				icon={CloudIcon}
				title={t("dashboard:dashboard.global_overview.stat4.title")}
				data={[
					[now + interval * 1, 383231 / 2.1],
					[now + interval * 2, 383231 / 2],
					[now + interval * 3, 383231 / 1.9],
					[now + interval * 4, 383231 / 1.7],
					[now + interval * 5, 383231 / 1.6],
					[now + interval * 6, 383231 / 1.3],
					[now + interval * 7, 383231 / 1.1],
					[now + interval * 8, 383231],
				].map(([time, value]) => ({
					date: `${time}`,
					value,
				}))}
			/>

			<MiniGraph
				icon={({ className }) => (
					<BsFillLightningFill size={24} className={className} />
				)}
				title={t("dashboard:dashboard.global_overview.stat2.title")}
				data={[
					[now + interval * 1, 90],
					[now + interval * 2, 92],
					[now + interval * 3, 140],
					[now + interval * 4, 180],
					[now + interval * 5, 280],
					[now + interval * 6, 310],
					[now + interval * 7, 369],
					[now + interval * 8, 400],
				].map(([time, value]) => ({
					date: `${time}`,
					value,
				}))}
			/>
		</>
	)
}
